import { Plus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export function NameList({ value = [], onChange, placeholder = "Nama", testId = "name-list" }) {
  const rows = value.length ? value : [""];
  const set = (i, v) => onChange(rows.map((r, j) => (j === i ? v : r)));
  const add = () => onChange([...rows, ""]);
  const remove = (i) => onChange(rows.length > 1 ? rows.filter((_, j) => j !== i) : [""]);
  return (
    <div className="space-y-1.5" data-testid={testId}>
      {rows.map((r, i) => (
        <div key={i} className="flex items-center gap-2">
          <span className="w-6 shrink-0 text-right font-mono text-xs text-muted-foreground">{i + 1}.</span>
          <Input value={r} onChange={(e) => set(i, e.target.value)} placeholder={`${placeholder} ${i + 1}`} data-testid={`${testId}-input-${i}`}
            onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); if (i === rows.length - 1) add(); } }} />
          <Button type="button" size="icon" variant="ghost" className="h-8 w-8 shrink-0" onClick={() => remove(i)} data-testid={`${testId}-remove-${i}`}><X className="h-4 w-4" /></Button>
        </div>
      ))}
      <Button type="button" size="sm" variant="outline" onClick={add} data-testid={`${testId}-add-btn`}><Plus className="mr-1 h-4 w-4" />Tambah baris nama</Button>
      <p className="text-[11px] text-muted-foreground">{rows.filter((r) => r.trim()).length} nama terisi · tekan Enter di baris terakhir untuk menambah baris</p>
    </div>
  );
}
